export default __webpack_public_path__ + "static/media/cta.1ed15c96.jpg";